import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@fiverr-private/fit';
import * as Translations from '../../../providers/i18n';
import BackButton from './BackIcon';
import './style.scss';

const { POSITIONS } = Tooltip;

// Until the old order page is dead, we use
// a custom selector in V2 to trigger a click event
// on this header "close button". Changing this class [btn-header-close] will cause it to fail.
// So make sure you're synced with v2 on this className

export const CloseBtn = ({ onClick, i18n }) => (
    <button onClick={onClick} className={'btn-header-close'}>
        <Tooltip content={<p className="tooltip">{i18n.t('attachments_preview.header.back')}</p>} className="tooltip-container" delay={true} position={POSITIONS.RIGHT}>
            <BackButton/>
        </Tooltip>
    </button>
);

CloseBtn.propTypes = {
    onClick: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(CloseBtn);
